import { RegionEnum } from '@common/enums/region.enum';
import { IEnvironment } from '@core/interfaces/environment.interface';

/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
export const environment: IEnvironment = {
  environment: 'development',
  projectId: 'linkhms',
  production: true,
  isServer: false,
  serverUrl: 'https://dev.linkhms.com/api/v1',
  socketGatewayUrl: 'wss://dev.linkhms.com',
  getFlowChartPeriod: 5000, // milliseconds
  dateFormat: 'yyyy-LL-dd',
  dateTimeFormat: 'yyyy-LL-dd H:mm',
  googleAnalyticsKey: 'G-6EPP5GV0C0',
  googleTagManagerId: '',
  crispWebsiteId: 'c66ef411-45f4-4b59-aa44-bf8013d62685',
  facebookPixelCode: '1106427170592490',
  googleClientId: '609427711699-8kgr4bj5hc7ip93n5erf04qjtr1c1tel.apps.googleusercontent.com',
  sentryDsn:
    'https://951da65ee9645e15744c822fc580c554@o4510073543327744.ingest.de.sentry.io/4510759276249168',
  mixpanelToken: 'd12cef7485852bbbcec67a8c4a73fe17',
  analyticsEnabled: true,
  deploymentRegion: 'af',
  availableRegions: [RegionEnum.af],
  mixpanelApiHost: 'https://api-eu.mixpanel.com',
};
